import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FcpButtonModule } from '../fcp-button';

import { FcpIconModuleSVG } from '../fcp-icon-svg';
import { FcpMenuComponent } from './fcp-menu.component';

@NgModule({
    declarations: [FcpMenuComponent],
    exports: [FcpMenuComponent],
    imports: [CommonModule, CdkMenuModule, FcpButtonModule, FcpIconModuleSVG]
})
export class FcpMenuModule {}
